import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';

import { LoopBackConfig } from "./../../../../shared/sdk/lb.config"; // Need Dependency - PageBuilder

import { ApiServiceProvider } from '../../../services/api/api-service'; // Need Dependency - PageBuilder

import { Response, Menu } from '../../../model/page-builder.model'; // Need Dependency - PageBuilder

@Injectable()
export class PageBuilderSubmenuApiProvider {

  public SFGoAuth: any;
  public SFGoStorage: any;

  public path: any;
  public oldPATHUrl: any;
  public newPATH: boolean = false;
  public newPATHUrl: any;

  constructor(
    public _http: Http,
    private _storage: Storage,
    private _apiServiceProvider: ApiServiceProvider) { 
  }

  async getStorage() {
    return new Promise(async (resolve) => {
      await this.getStorageSfGoAuth();
      await this.getStorageSfGoStorage();
      resolve(true);
    });
  }
  
  async getStorageSfGoStorage(): Promise<any> {
    // console.log("TCL: Get Storage");
    return new Promise((resolve) => {
        this._storage.ready().then(() => {
            this._storage.get('SFGoStorage').then(async (hasil) => {
                if (hasil != null && hasil != undefined) {
                    this.SFGoStorage = JSON.parse(hasil);
                    if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin) {
                      this.oldPATHUrl = this.SFGoStorage.storedPrelogin.GOPATH;
                    } else {
                      this.oldPATHUrl = this.path;
                    }
                    let path;
                    if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin && 
                        this.SFGoStorage.storedPrelogin.hasOwnProperty('GOPATHNEW') && this.SFGoStorage.storedPrelogin.GOPATHNEW) {
                        // console.log("TCL: New Path Found");
                        this.newPATH = true;
                        path = this.SFGoStorage.storedPrelogin.GOPATHNEW;
                        this.newPATHUrl = path;
                    } else {
                        // console.log("TCL: New Path Not Found");
                        this.newPATH = false;
                    }
                    // this.newPATHUrl = 'http://localhost:30000' // local nestjs; 
                    // this.newPATHUrl = 'http://localhost:5000' // local loopback; 
                    resolve(true);
                }
            });
        });
    });
  }

  getStorageSfGoAuth(): Promise<any> {
    return new Promise(async (resolve) => {
      this.path = LoopBackConfig.getPath();
      // console.log('TCL: ', this.path);
      this._storage.ready().then(() => {
          this._storage.get('SFGoAuth').then(hasil => {
              if (hasil != null && hasil != undefined) {
                  this.SFGoAuth = JSON.parse(hasil);
                  resolve(true);
              }
          });
      });
    })
  }
  
  getSubmenu(menuId): Promise<any> {
    return new Promise(async (resolve) => {
      await this.getStorage();

      let lang = await this._storage.get('language');
      if (lang == undefined || lang == null) {
        lang = 'en'
        await this._storage.set('language', lang) // force add lang to storage
      }

      let pageBuilderSubmenu = await this._storage.get("pageBuilderSubmenu");
      try {
        pageBuilderSubmenu = JSON.parse(pageBuilderSubmenu);
      } catch (e) {
        pageBuilderSubmenu = pageBuilderSubmenu;
      }

      const urlParams = '&lang=' + lang + '&menuId=' + menuId;
      this._apiServiceProvider.api('GET', urlParams, null, '/api/BuilderServices/getSubMenuV2', '/builder/getSubMenuV2', null, true).then(async (response: Response<Menu>) => {
        if (response.data) {
          if (pageBuilderSubmenu) {
            pageBuilderSubmenu[menuId] = response.data;
            this._storage.set("pageBuilderSubmenu", JSON.stringify(pageBuilderSubmenu));
          } else {
            pageBuilderSubmenu = {};
            pageBuilderSubmenu[menuId] = response.data;
            this._storage.set("pageBuilderSubmenu", JSON.stringify(pageBuilderSubmenu));
          }
          resolve(response.data);
        } else {
            if (pageBuilderSubmenu && pageBuilderSubmenu[menuId]) {
              resolve(pageBuilderSubmenu[menuId]);
              return;
            }
            resolve([]);
        }
        resolve(response);
      }, error => {
        if (pageBuilderSubmenu && pageBuilderSubmenu[menuId]) {
          resolve(pageBuilderSubmenu[menuId]);
          return;
        }
        resolve([]);
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/pagebuilder/services/menu/submenu/pagebuilder-submenu-api.ts